// export const baseUrl = "http://localhost:5001/api";
export const baseUrl = "http://api.ithoob.com:5001/api/";
// export const herokuUrl = "https://ithoob-heroku.herokuapp.com/api";
// export const herokuUrl = "http://localhost:5001/api";
export const herokuUrl = "https://api.ithoob.com:5002/api";
